module.exports = __webpack_public_path__ + "img/06.3f5e1fbf.png";